import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';
import { useModelStateSetedValue } from '@/shared/components/configurator/atoms/banners-state-seted';
import {
    useConfiguratorOpenedCameraPositionValue,
    useSetCameraPosition,
} from '@/shared/components/configurator/atoms/camera-position';
import {
    useConfiguratorStepValue,
    useSetConfiguratorStepState,
} from '@/shared/components/configurator/atoms/configurator-step-state';
import { useConfiguratorZoomedSetState } from '@/shared/components/configurator/atoms/configurator-zoomed';
import { ModelState, useCurrentModelStateValue } from '@/shared/components/configurator/atoms/current-model-state';
import { useCurrentPavilionValue } from '../atoms/current-pavilion';
import ConfiguratorBanners from './ConfiguratorBanners';
import ConfiguratorColor from './ConfiguratorColor';
import ConfiguratorForm from './ConfiguratorForm';
import ConfiguratorGroupPicker from './ConfiguratorGroupPicker';
import ConfiguratorHero from './ConfiguratorHero';
import ConfiguratorMultiPicker from './ConfiguratorMultiPicker';
import ConfiguratorPicker from './ConfiguratorPicker';

const Configurator = () => {
    const step = useConfiguratorStepValue();
    const setStep = useSetConfiguratorStepState();
    const setCameraPosition = useSetCameraPosition();
    const configuratorOpenedCameraPosition = useConfiguratorOpenedCameraPositionValue();
    const setConfiguratorZoomed = useConfiguratorZoomedSetState();
    const slug = useCurrentPavilionValue();

    const onClick = useCallback(() => {
        setStep('hero');
        setCameraPosition(configuratorOpenedCameraPosition);
        setConfiguratorZoomed(false);
    }, [setStep, setCameraPosition, setConfiguratorZoomed, configuratorOpenedCameraPosition]);

    const currentModelState = useCurrentModelStateValue();
    const router = useRouter();
    const modelStateSeted = useModelStateSetedValue();
    useEffect(() => {
        if (modelStateSeted) {
            const query: Record<any, string> = {};
            for (const key in currentModelState) {
                const obj = currentModelState[key as keyof ModelState];
                if (Array.isArray(obj)) {
                    let str = '';
                    obj.forEach((item, i) => {
                        if (i === 0) {
                            str += item.value;
                        } else {
                            str += `-and-${item.value}`;
                        }
                    });
                    query[key] = str;
                } else {
                    if (obj) {
                        query[key] = (obj as any).value;
                    }
                }
            }

            router.push({ pathname: router.pathname, query: { ...query, slug } }, undefined, { shallow: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentModelState, modelStateSeted, slug]);

    useEffect(() => {
        return () => {
            setStep('hero');
        };
    }, [setStep]);

    return slug ? (
        <>
            {step === 'hero' && <ConfiguratorHero slug={slug} />}
            {step === 'color' && <ConfiguratorColor />}
            {step === 'picker' && <ConfiguratorPicker />}
            {step === 'group' && <ConfiguratorGroupPicker />}
            {step === 'multipicker' && <ConfiguratorMultiPicker />}
            {step === 'banners' && <ConfiguratorBanners />}
            {step === 'form' && <ConfiguratorForm slug={slug} onClick={onClick} />}
        </>
    ) : null;
};

export default Configurator;
